
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

// d.ts
import { DCRecord, IDataController } from "@/@types/lib/dataController"

// Custom Components
import ModelTable from "@/ui/Table/ModelTable";
import TableButtonEdit from "@/ui/Table/ActionButtons/TableButtonEdit";
import LoaderContext from "@/components/LoaderContext/LoaderContext";

import model from "@/models/komentari";
import dataController from "@/lib/dataController";

import { LoaderContextType } from "@/@types/context/LoaderContext";
import { Grid,Box } from "@mui/material";
import { Extent } from "ol/interaction";

function AllObjectCommentsTable(props: any) {
  const loaderContext = useContext(LoaderContext) as LoaderContextType;

  const { t } = useTranslation();

  const handleAddComment = props.handleAddComment;
  const records = props.records;

  const dc: IDataController = new dataController(model);

  // useEffect(() => {
  //   refreshRecords();
  // }, []);

  // useEffect(() => {
  //   refreshRecords();
  // }, [objektId]);

  // const refreshRecords = () => {
  //   loaderContext.toggleLoading(true);
  
  //   const customPath = "komentari"; // ?public=0
  //   if (objektId!==null)
  //   { dc.GetData(customPath).then((resp) => {
  //       if (resp.success) {
  //         if (Array.isArray(resp.data)) {
            
  //             const filteredRecords  = resp.data.filter((record) => {
  //               return record.objekt_id === objektId;
  //             })
      
  //             setRecords(filteredRecords);
  //         }
  //         else {
      
  //             setRecords([]);
  //         }
  //       };
  //     }).finally(() => {
  //       loaderContext.toggleLoading(false);
  //     });
  //   }
  // };

  return (
    <Box height={"100%"}>
      
      <ModelTable
        title={""}
        records={records}
        dc={dc}
        allowSelection="none"
        allowFilter={false}
        allowExport={false}
        allowColumnPicker={false}
        allowAdd={true}
        addLabel={t("titles.add_comment")}
        handleAdd={handleAddComment}
        forceIconButtons
        onRowClick={()=>{}}
        onRowAction={()=>{}}
        allowRowAction={() => { return true; }}
        viewName="map"
        initialPageSize={5}
      >
      </ModelTable>
    </Box>
  );
}

export default AllObjectCommentsTable;
